import CryptoJS from 'crypto-js';
import configData from '../config.json';

// Same scheme as quick apply registration: AES-CBC with a random numeric IV, sent as `${iv}${cipherText}`.
export const encryptPassword = (password) => {
  const privateKey = CryptoJS.enc.Utf8.parse(configData.REACT_QUICK_APPLY_SECRET);
  const ivKey = parseInt(Math.random().toFixed(16).replace('0.', ''), 10);
  const ivGeneratedKey = CryptoJS.enc.Utf8.parse(ivKey);

  const encryptedPassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(password), privateKey, {
    keySize: 128 / 8,
    iv: ivGeneratedKey,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString();

  return ivKey.toString().concat(encryptedPassword);
};
